__webpack_require__.p = "/showdownpuzzle/";